export default __webpack_public_path__ + "static/ProValue_5@768-b42e03a8d453643975ad3e74b4928bd5.png";